export default "__VITE_ASSET__57e29100__"